import { render } from "./employees-grid.vue?vue&type=template&id=1a2fc1dd"
import script from "./employees-grid.vue?vue&type=script&lang=js"
export * from "./employees-grid.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__